<template>
	<div>
		<div
			class="modal fade"
			id="previewModal"
			tabindex="-1"
			role="dialog"
			aria-labelledby="openModal"
			aria-hidden="true"
			data-backdrop="static"
		>
			<div class="modal-dialog modal-lg" role="document" >
				<div
					class="modal-content campaign-g-addedit"
					style="width:1000px;height:260px;margin-left:-49px"
				>
					<div class="modal-header" style = "flex: 0 0 auto">
						<h5 class="modal-title" id="exampleModalLongTitle">{{previewTemplateData.title}}</h5>
						<!-- <button type="button" class="close" data-dismiss="modal" @click = "reset()">
							<span aria-hidden="true">&times;</span>
						</button> -->
					</div>
					<div class="modal-body" style="margin-top:25px">
						<ckeditor v-model="previewTemplateData.template"  :config="editorConfig" id = "textAreaEditor" :editor-url = "templateURl + '/ckeditor_plugins/ckeditor.js'" :read-only="true"></ckeditor>
					</div>

					<div class="modal-footer" style = "flex:0 0 auto">
						<div class="mt-2" style="text-align: center">
							<button type="button" class="btn btn-primary" data-dismiss="modal" @click = "reset()">Done</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import { templateURl } from '@/properties';
import {campaignTable} from './templates/campaignTable.js';
import {productTable} from './templates/productTable.js';

	export default {
		name: "PreviewTemplate",
		props:["previewTemplateData"],
		watch:{

		},
		data() {
			return {
				editorConfig:{
					toolbarGroups: [
						{ name: 'insert' },
		                { name: 'document', groups: ['mode'] },
						{ name: 'basicstyles'},
						{ name: 'paragraph', groups: [ 'align', 'list'] },
						{ name: 'styles'}

				 ],
				 removePlugins: 'font,iframe,pagebreak,flash,stylescombo,print,preview,save,smiley,pastetext,pastefromword',
				 removeButtons: 'Anchor,Font,Strike,Subscript,Superscript,Table,HorizontalRule,SpecialChar',
				 strinsert_strings: [],
				 strinsert_button_label: 'Tokens',
				 strinsert_button_title: 'Insert token',
				 custom_tables: [
					 {
						 'groupName': 'Campaign',
						 'tables': [
							 {	table: campaignTable,
								 name: 'Campaign Table', label: 'Campaign Table'
							 }
						 ]
					 },
					 {
						 'groupName': 'Product',
						 'tables': [
							 {
								 table: productTable,
								 name: 'Product Table', label: 'Product Table'
							 }
						 ]
					 }

				 ],
				 custom_tables_button_label: 'Custom Tables',
				 custom_tables_button_title: 'Select Custom Tables',
				 allowedContent: true
			   },
			   editorData:'',
			   campaignTable:campaignTable,
			   productTable:productTable,
			   templateURl:templateURl,
			};
		},
		components: {
		},
		mounted() {
			if(this.previewTemplateData && Object.keys(this.previewTemplateData).length){
      			$("#previewModal").modal("show");
			}
		},
		watch: {},
		methods: {
			reset(){
				this.$emit("closePopUp")
			},
		}

	};
</script>
<style lang="scss">
</style>